import type { RiskAssessmentResult, RiskAssessmentScoredResult, RiskAssessmentTemplate } from '@gcv/shared';
import { RiskAssessmentResultStatus, RiskAssessmentResultType } from '@gcv/shared';

export interface OpenAssessmentSummary {
  id: string;
  templateName: string;
  status: RiskAssessmentResultStatus;
  dueDate?: string;
  sentOn: string;
}

const OPEN_STATUSES = [RiskAssessmentResultStatus.Open, RiskAssessmentResultStatus.InProgress];

export const getOpenAssessments = (
  assessments: RiskAssessmentResult[] = [],
  templates: RiskAssessmentTemplate[] = []
): OpenAssessmentSummary[] => {
  const templateNames = new Map(templates.map((t) => [t.risk_assessment_template_id, t.name]));

  return assessments
    .filter(
      (assessment): assessment is RiskAssessmentScoredResult =>
        assessment.type === RiskAssessmentResultType.Assessment && OPEN_STATUSES.includes(assessment.status)
    )
    .map((assessment) => ({
      id: assessment.id,
      templateName: templateNames.get(assessment.risk_assessment_template_id) ?? 'Risk Assessment',
      status: assessment.status,
      dueDate: assessment.due_date,
      sentOn: assessment.sent_on
    }))
    .sort((a, b) => b.sentOn.localeCompare(a.sentOn));
};
